import { Components, formLabelClasses, Theme } from '@mui/material';

export const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${formLabelClasses.focused}`]: {
        color: 'inherit', // prevent label from changing color when focused
      },
      ...(theme.featureFlags.panwRebrandStubYear && {
        [`&.${formLabelClasses.error}`]: {
          color: `${theme.palette.input.placeholderColor} !important`,
        },
      }),
    }),
  },
};
